export const baseUrl = {
	dev: 'https://tsdev.neux.com.tw',
	sit: 'https://tssit.neux.com.tw',
	uat: 'https://tsuat.neux.com.tw',
	prod: 'https://friendly.tssco.com.tw',
	tsscouat: 'https://newtestfriendly.tssco.com.tw'
}

export const apiData = {
	dev: {
		news: `${baseUrl.dev}/portal-api/DataSource/news/portal`,
		newsDetail: `${baseUrl.dev}/portal-api/NewsDetail`,
		location: `${baseUrl.dev}/portal-api/ServiceBranch/Search`,
		qa: `${baseUrl.dev}/portal-api/AccessibleQa`,
	},
	sit: {
		news: `${baseUrl.sit}/portal-api/DataSource/news/portal`,
		newsDetail: `${baseUrl.sit}/portal-api/NewsDetail`,
		location: `${baseUrl.sit}/portal-api/ServiceBranch/Search`,
		qa: `${baseUrl.sit}/portal-api/AccessibleQa`,
	},
	uat: {
		news: `${baseUrl.uat}/portal-api/DataSource/news/portal`,
		newsDetail: `${baseUrl.uat}/portal-api/NewsDetail`,
		location: `${baseUrl.uat}/portal-api/ServiceBranch/Search`,
		qa: `${baseUrl.uat}/portal-api/AccessibleQa`,
	},
	prod: {
		news: `${baseUrl.prod}/portal-api/DataSource/news/portal`,
		newsDetail: `${baseUrl.prod}/portal-api/NewsDetail`,
		location: `${baseUrl.prod}/portal-api/ServiceBranch/Search`,
		qa: `${baseUrl.prod}/portal-api/AccessibleQa`,
	},
	tsscouat: {
		news: `${baseUrl.tsscouat}/portal-api/DataSource/news/portal`,
		newsDetail: `${baseUrl.tsscouat}/portal-api/NewsDetail`,
		location: `${baseUrl.tsscouat}/portal-api/ServiceBranch/Search`,
		qa: `${baseUrl.tsscouat}/portal-api/AccessibleQa`,
	},
}